const BoldTableCell = ({ children, className = "", scope = "col", ...props }) => (
    <th scope={scope} {...props} className={`px-4 py-2 text-left font-semibold ${className}`}>
        {children}
    </th>
);

export default BoldTableCell;